/**
 * Country names and codes for Chilean invoicing (SII/SimpleFactura).
 * Chile (997) is the default for users without a country value.
 */
export const CHILE_CODE = 997;

export const COUNTRY_OPTIONS = [
  { value: 308, text: "AFGHANISTAN" },
  { value: 518, text: "ALBANIA" },
  { value: 563, text: "ALEMANIA" },
  { value: 525, text: "ANDORRA" },
  { value: 140, text: "ANGOLA" },
  { value: 242, text: "ANGUILA" },
  { value: 240, text: "ANTIGUA Y BARBUDA" },
  { value: 247, text: "ANTILLAS NEERLANDESAS" },
  { value: 302, text: "ARABIA SAUDITA" },
  { value: 127, text: "ARGELIA" },
  { value: 224, text: "ARGENTINA" },
  { value: 540, text: "ARMENIA" },
  { value: 243, text: "ARUBA" },
  { value: 406, text: "AUSTRALIA" },
  { value: 509, text: "AUSTRIA" },
  { value: 541, text: "AZERBAIJAN" },
  { value: 207, text: "BAHAMAS" },
  { value: 313, text: "BAHREIN" },
  { value: 321, text: "BANGLADESH" },
  { value: 204, text: "BARBADOS" },
  { value: 542, text: "BELARUS" },
  { value: 420, text: "BELAU" },
  { value: 514, text: "BELGICA" },
  { value: 236, text: "BELICE" },
  { value: 150, text: "BENIN" },
  { value: 244, text: "BERMUDAS" },
  { value: 543, text: "BOSNIA Y HERZEGOVINA" },
  { value: 113, text: "BOTSWANA" },
  { value: 220, text: "BRASIL" },
  { value: 344, text: "BRUNEI" },
  { value: 527, text: "BULGARIA" },
  { value: 161, text: "BURKINA FASO" },
  { value: 141, text: "BURUNDI" },
  { value: 318, text: "BUTAN" },
  { value: 129, text: "CABO VERDE" },
  { value: 315, text: "CAMBODIA" },
  { value: 149, text: "CAMERUN" },
  { value: 226, text: "CANADA" },
  { value: 130, text: "CHAD" },
  { value: 997, text: "CHILE" },
  { value: 336, text: "CHINA" },
  { value: 305, text: "CHIPRE" },
  { value: 202, text: "COLOMBIA" },
  { value: 118, text: "COMORAS" },
  { value: 144, text: "CONGO" },
  { value: 334, text: "COREA DEL NORTE" },
  { value: 333, text: "COREA DEL SUR" },
  { value: 107, text: "COSTA DE MARFIL" },
  { value: 211, text: "COSTA RICA" },
  { value: 547, text: "CROACIA" },
  { value: 209, text: "CUBA" },
  { value: 507, text: "DINAMARCA" },
  { value: 155, text: "DJIBOUTI" },
  { value: 231, text: "DOMINICA" },
  { value: 218, text: "ECUADOR" },
  { value: 124, text: "EGIPTO" },
  { value: 213, text: "EL SALVADOR" },
  { value: 341, text: "EMIRATOS ARABES UNIDOS" },
  { value: 163, text: "ERITREA" },
  { value: 548, text: "ESLOVENIA" },
  { value: 517, text: "ESPAÑA" },
  { value: 225, text: "ESTADOS UNIDOS DE AMÉRICA" },
  { value: 549, text: "ESTONIA" },
  { value: 139, text: "ETIOPIA" },
  { value: 401, text: "FIJI" },
  { value: 335, text: "FILIPINAS" },
  { value: 512, text: "FINLANDIA" },
  { value: 505, text: "FRANCIA" },
  { value: 145, text: "GABON" },
  { value: 102, text: "GAMBIA" },
  { value: 550, text: "GEORGIA" },
  { value: 108, text: "GHANA" },
  { value: 565, text: "GIBRALTAR" },
  { value: 232, text: "GRANADA" },
  { value: 520, text: "GRECIA" },
  { value: 253, text: "GROENLANDIA" },
  { value: 425, text: "GUAM" },
  { value: 215, text: "GUATEMALA" },
  { value: 566, text: "GUERNSEY" },
  { value: 104, text: "GUINEA" },
  { value: 103, text: "GUINEA - BISSAU" },
  { value: 147, text: "GUINEA ECUATORIAL" },
  { value: 217, text: "GUYANA" },
  { value: 208, text: "HAITI" },
  { value: 515, text: "PAÍSES BAJOS" },
  { value: 214, text: "HONDURAS" },
  { value: 342, text: "HONG KONG - REGIÓN ADMINISTRATIVA ESPECIAL DE CHINA" },
  { value: 530, text: "HUNGRIA" },
  { value: 317, text: "INDIA" },
  { value: 328, text: "INDONESIA" },
  { value: 307, text: "IRAK" },
  { value: 309, text: "IRAN" },
  { value: 506, text: "IRLANDA" },
  { value: 516, text: "ISLANDIA" },
  { value: 246, text: "ISLAS CAYMAN" },
  { value: 427, text: "ISLAS COOK" },
  { value: 567, text: "ISLAS DE MAN" },
  { value: 327, text: "ISLAS MALDIVAS" },
  { value: 424, text: "ISLAS MARIANAS DEL NORTE" },
  { value: 164, text: "ISLAS MARSHALL" },
  { value: 418, text: "ISLAS SALOMON" },
  { value: 403, text: "ISLAS TONGA" },
  { value: 249, text: "ISLAS VIRGENES (ESTADOS UNIDOS DE AMERICA)" },
  { value: 245, text: "ISLAS VIRGENES BRITANICAS" },
  { value: 306, text: "ISRAEL" },
  { value: 504, text: "ITALIA" },
  { value: 205, text: "JAMAICA" },
  { value: 331, text: "JAPON" },
  { value: 568, text: "JERSEY" },
  { value: 301, text: "JORDANIA" },
  { value: 551, text: "KASAJSTAN" },
  { value: 137, text: "KENIA" },
  { value: 552, text: "KIRGISTAN" },
  { value: 416, text: "KIRIBATI" },
  { value: 303, text: "KUWAIT" },
  { value: 316, text: "LAOS" },
  { value: 114, text: "LESOTHO" },
  { value: 553, text: "LETONIA" },
  { value: 311, text: "LIBANO" },
  { value: 106, text: "LIBERIA" },
  { value: 125, text: "LIBIA" },
  { value: 534, text: "LIECHTENSTEIN" },
  { value: 554, text: "LITUANIA" },
  { value: 532, text: "LUXEMBURGO" },
  { value: 345, text: "MACAO" },
  { value: 555, text: "MACEDONIA" },
  { value: 120, text: "MADAGASCAR" },
  { value: 329, text: "MALASIA" },
  { value: 115, text: "MALAWI" },
  { value: 133, text: "MALI" },
  { value: 523, text: "MALTA" },
  { value: 128, text: "MARRUECOS" },
  { value: 250, text: "MARTINICA" },
  { value: 119, text: "MAURICIO" },
  { value: 134, text: "MAURITANIA" },
  { value: 216, text: "MEXICO" },
  { value: 417, text: "MICRONESIA" },
  { value: 556, text: "MOLDOVA" },
  { value: 535, text: "MONACO" },
  { value: 337, text: "MONGOLIA" },
  { value: 252, text: "MONSERRAT" },
  { value: 561, text: "MONTENEGRO" },
  { value: 121, text: "MOZAMBIQUE" },
  { value: 326, text: "MYANMAR (EX BIRMANIA)" },
  { value: 159, text: "NAMIBIA" },
  { value: 402, text: "NAURU" },
  { value: 320, text: "NEPAL" },
  { value: 212, text: "NICARAGUA" },
  { value: 131, text: "NIGER" },
  { value: 111, text: "NIGERIA" },
  { value: 421, text: "NIUE" },
  { value: 513, text: "NORUEGA" },
  { value: 423, text: "NUEVA CALEDONIA" },
  { value: 405, text: "NUEVA ZELANDIA" },
  { value: 304, text: "OMAN" },
  { value: 324, text: "PAKISTAN" },
  { value: 322, text: "PALESTINA" },
  { value: 210, text: "PANAMA" },
  { value: 412, text: "PAPUA, NUEVA GUINEA" },
  { value: 222, text: "PARAGUAY" },
  { value: 219, text: "PERU" },
  { value: 422, text: "POLINESIA FRANCESA" },
  { value: 528, text: "POLONIA" },
  { value: 501, text: "PORTUGAL" },
  { value: 251, text: "PUERTO RICO" },
  { value: 312, text: "QATAR" },
  { value: 510, text: "REINO UNIDO" },
  { value: 148, text: "REPUBLICA CENTRO AFRICANA" },
  { value: 544, text: "REPUBLICA CHECA (D)" },
  { value: 546, text: "REPUBLICA DE SERBIA" },
  { value: 346, text: "REPUBLICA DE YEMEN" },
  { value: 143, text: "REPUBLICA DEMOCRATICA DEL CONGO" },
  { value: 206, text: "REPUBLICA DOMINICANA" },
  { value: 545, text: "REPUBLICA ESLOVACA (D)" },
  { value: 519, text: "RUMANIA" },
  { value: 562, text: "RUSIA (B)" },
  { value: 142, text: "RWANDA" },
  { value: 165, text: "SAHARA OCCIDENTAL" },
  { value: 241, text: "SAINT KITTS & NEVIS" },
  { value: 404, text: "SAMOA OCCIDENTAL" },
  { value: 536, text: "SAN MARINO" },
  { value: 234, text: "SAN VICENTE Y LAS GRANADINAS" },
  { value: 233, text: "SANTA LUCIA (ISLAS OCCIDENTALES)" },
  { value: 524, text: "SANTA SEDE" },
  { value: 146, text: "SAO TOME Y PRINCIPE" },
  { value: 101, text: "SENEGAL" },
  { value: 156, text: "SEYCHELLES" },
  { value: 105, text: "SIERRA LEONA" },
  { value: 332, text: "SINGAPUR" },
  { value: 310, text: "SIRIA" },
  { value: 138, text: "SOMALIA" },
  { value: 314, text: "SRI LANKA" },
  { value: 112, text: "SUDAFRICA" },
  { value: 123, text: "SUDAN" },
  { value: 160, text: "SUDAN DEL SUR" },
  { value: 511, text: "SUECIA" },
  { value: 508, text: "SUIZA" },
  { value: 235, text: "SURINAM" },
  { value: 122, text: "SWAZILANDIA" },
  { value: 557, text: "TADJIKISTAN" },
  { value: 330, text: "TAIWAN (FORMOSA)" },
  { value: 135, text: "TANZANIA" },
  { value: 151, text: "TERRITORIO BRITÁNICO EN AFRICA" },
  { value: 227, text: "TERRITORIO BRITÁNICO EN AMERICA" },
  { value: 407, text: "TERRITORIO BRITÁNICO EN OCEANIA Y EL PACIFICO" },
  { value: 230, text: "TERRITORIO DE DINAMARCA" },
  { value: 152, text: "TERRITORIO ESPAÑOL EN AFRICA" },
  { value: 153, text: "TERRITORIO FRANCES EN AFRICA" },
  { value: 228, text: "TERRITORIO FRANCES EN AMERICA" },
  { value: 408, text: "TERRITORIO FRANCES EN OCEANIA Y EL PACIFICO" },
  { value: 229, text: "TERRITORIO HOLANDES EN AMERICA" },
  { value: 409, text: "TERRITORIO NORTEAMERICANO EN OCEANIA Y EL PACIFICO" },
  { value: 343, text: "TERRITORIO PORTUGUES EN ASIA" },
  { value: 319, text: "THAILANDIA" },
  { value: 426, text: "TIMOR ORIENTAL" },
  { value: 109, text: "TOGO" },
  { value: 203, text: "TRINIDAD Y TOBAGO" },
  { value: 126, text: "TUNEZ" },
  { value: 248, text: "TURCAS Y CAICOS" },
  { value: 558, text: "TURKMENISTAN" },
  { value: 522, text: "TURQUIA" },
  { value: 419, text: "TUVALU" },
  { value: 559, text: "UCRANIA" },
  { value: 136, text: "UGANDA" },
  { value: 223, text: "URUGUAY" },
  { value: 560, text: "UZBEKISTAN" },
  { value: 415, text: "VANUATU" },
  { value: 201, text: "VENEZUELA" },
  { value: 325, text: "VIETNAM" },
  { value: 117, text: "ZAMBIA" },
  { value: 116, text: "ZIMBABWE" },
  { value: 902, text: "Aprovisionamiento (\"Rancho\") de naves y aeronaves extranjeras y de maderas para estibar mercancías cargadas en puertos chilenos" },
  { value: 901, text: "Combustibles y lubricantes destinados al consumo de naves y aeronaves extranjeras y de revistas con el mismo objeto" },
  { value: 906, text: "Depósito Franco" },
  { value: 998, text: "Nacional Reputada" },
  { value: 904, text: "Orígenes o Destinaciones no precisadas por razones comerciales o militares" },
  { value: 999, text: "Otros (País Desconocido)" },
  { value: 903, text: "Pesca Extraterritorial" },
  { value: 910, text: "Zona Franca Arica, Zona Industrial" },
  { value: 905, text: "Zona Franca Iquique" },
  { value: 907, text: "Zona Franca Punta Arenas" },
];

/**
 * Resolve stored country value to a valid code.
 * Users without a value get Chile (997) by default.
 */
export function resolveCountryCode(value) {
  if (value == null || value === "") return CHILE_CODE;
  const num = Number(value);
  if (!Number.isNaN(num) && COUNTRY_OPTIONS.some((c) => c.value === num)) {
    return num;
  }
  const lower = String(value).toLowerCase().trim();
  if (lower === "chile") return CHILE_CODE;
  const found = COUNTRY_OPTIONS.find((c) => c.text.toLowerCase() === lower);
  return found ? found.value : CHILE_CODE;
}
